export const enum ThemeColors {
  Primary = '#d6232b'
}
